<template>
  <div class="flex-modal-grow-cleed NooClass">
    <ArrowBack :old-selected-option="oldSelectedOption" @update-old-selected-option="updateOldSelectedOption" />
    <div v-if="isError" style="display: block; margin: auto; text-align: center; margin-top: 50%;">
      <Title :title="valueText['modal_size_reco']['error']['text']" :level="2"></Title>
      <ButtonSubmit :text="valueText['modal_size_reco']['buttonClose']"
                    class-name="validateButtonSubmitNoo-cleed validateCursorPointer-cleed" @submitButton="$emit('close')"
      />
    </div>
    <div v-else-if="isLoading" class="loader-center">
      <loading color="rgb(214, 205, 189)" />
    </div>
    <div v-else class="flex-modal-grow-cleed">
      <div v-if="selectedOption === '1'" class="modal-first-view-cleed flex-modal-grow-cleed flex-modal-center-xy-cleed ">
        <Title :title="valueText['modal_size_reco']['1']['title'] + '\n' + valueText['modal_size_reco']['1']['subtitle']"
               :level="2" style="white-space: pre-line !important;"
        />
        <ProductView :view-type="'view_1'" :product-img-link="productImgLink" :product-name="productName"
                     :product-price="productPrice"
        />
        <ButtonSubmit :text="valueText['modal_size_reco']['1']['button']"
                      class-name="validateButtonSubmitNoo-cleed validateCursorPointer-cleed bold-style-cleed" @submitButton="getNooSizes('1')"
        />
      </div>
      <div
        v-else-if="selectedOption === '2' || selectedOption === '3' || selectedOption === '4' || selectedOption === '5'"
      >
        <ProductView :view-type="'view_2'" :product-img-link="productImgLink" :product-name="productName"
                     :product-price="null"
        />
        <div v-if="selectedOption === '2'">
          <TextAndButtons :text="valueText['modal_size_reco']['2']['subtitle']" :buttons-list="buttonsList"
                          style-value-buttons="font-weight: bold;"
                          class-name-buttons="validateButtonSubmitNoo-cleed rounded validateCursorPointer-cleed" class-grid="grid-2"
                          :next-selected-option="nextStep2" @update-selected-option="getNooSizes('2')" @update-input="updateInput2"
          />
        </div>
        <div v-else-if="selectedOption === '3'">
          <TextAndButtons :text="questionStep3" :buttons-list="buttonsList3"
                          style-value-buttons="font-weight: bold;"
                          class-name-buttons="validateButtonSubmitNoo-cleed rounded2 validateCursorPointer-cleed" class-grid="grid-3"
                          :next-selected-option="nextStep3" @update-selected-option="updateSelectedOption"
                          @update-input="updateInput3"
          />
        </div>
        <div v-else-if="selectedOption === '4'">
          <TextAndButtons :text="questionStep4" :buttons-list="buttonsList4"
                          style-value-buttons="font-weight: bold;"
                          class-name-buttons="validateButtonSubmitNoo-cleed rounded4 preline validateCursorPointer-cleed" class-grid="grid-4"
                          :next-selected-option="nextStep4" @update-selected-option="updateSelectedOption"
                          @update-input="updateInput4"
          />
        </div>
        <div v-else-if="selectedOption === '5'">
          <TextAndButtons :text="questionStep5" :buttons-list="buttonsList5"
                          style-value-buttons="font-weight: bold;"
                          class-name-buttons="validateButtonSubmitNoo-cleed rounded validateCursorPointer-cleed" class-grid="grid-4"
                          :next-selected-option="nextStep5" @update-selected-option="updateSelectedOption"
                          @update-input="updateInput5"
          />
        </div>
      </div>
      <div v-else-if="selectedOption === '6'" class="flex-modal-grow-cleed flex-modal-center-xy-cleed">
        <div v-if="resultSizes.value === undefined || resultSizes.value === null || resultSizes.value === 'NC'">
          <Title :title="valueText['norm']['warning_null']" :level="2"></Title>
          <ButtonSubmit :text="valueText['modal_size_reco']['doubt']['text_underline']"
                        class-name="validateButtonSubmitNoo-cleed validateCursorPointer-cleed" @submitButton="$emit('contact-us');"
          />
        </div>
        <ResultSizeRecoNoo v-else :value-text="valueText['modal_size_reco']['6']" :result-sizes="resultSizes"
                           @add-to-cart="addToCart"
        />
      </div>
      <wizard-steps v-if="selectedOption !== '1' && selectedOption !== '6' && oldSelectedOption.length > 0"
                    :step="oldSelectedOption.length" :total="this.totalSteps"
      />
    </div>
  </div>
</template>

<script>
import store from "../../store";
import ArrowBack from "@/components/modal/ui/ArrowBack.vue";
import Title from "@/components/modal/ui/Title.vue";
import ButtonSubmit from "@/components/modal/ui/ButtonSubmit.vue";
import WizardSteps from "@/components/modal/ui/WizardSteps.vue";
import ProductView from "@/components/modal/ui/ProductView.vue";
import TextAndButtons from "@/components/modal/partials/TextAndButtons.vue";
import ResultSizeRecoNoo from "@/components/modal/partials/ResultSizeRecoNoo.vue";
import Loading from "@/components/modal/ui/Loading.vue";
import { customLogger } from "@/utils";

export default {
  name: "SizeRecommendationNoo",
  components: {
    ArrowBack,
    Title,
    ButtonSubmit,
    ProductView,
    TextAndButtons,
    ResultSizeRecoNoo,
    WizardSteps,
    Loading,
  },
  props: {
    valueText: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      selectedOption: '1',
      totalSteps: 4,
      oldSelectedOption: [],
      isError: store.state.user.modal_reco_sizeError,
      productLink: '',
      productImgLink: '',
      productName: '',
      productPrice: '',
      buttonsList: [
        {
          text: 'FR',
        },
        {
          text: 'EU',
        },
      ],
      nextStep2: '',
      buttonsList3: [],
      nextStep3: '',
      questionStep3: '',
      buttonsList4: [],
      nextStep4: '',
      questionStep4: '',
      buttonsList5: [],
      nextStep5: '',
      questionStep5: '',
      resultSizes: {
        value: '',
        response_one: '',
        response_two: '',
        response_three: '',
      },
      isLoading: false,
    };
  },
  mounted() {
    document.querySelectorAll('.wrapper-cleed .NooClass').forEach(function(element) {
      element.closest('.wrapper-cleed').classList.add('has-NooClass');
    });
    document.querySelectorAll('.modal-size-advice-cleed .wrapper-cleed .NooClass').forEach(function(element) {
      element.closest('.modal-size-advice-cleed').classList.add('modal-size-advice-cleed-has-NooClass');
    });
    this.$nextTick(async () => {
      await this.verifyProductExist();
    });
  },
  methods: {
    resetSelectedOption() {
      this.oldSelectedOption = [];
      this.selectedOption = '1';
      this.isError = 0;

      // customLogger("resetSelectedOption");
    },
    async updateSelectedOption(option) {
      if (option === '6')
      {
        if (window.matomoTracker) {
          customLogger("final step modal");
          matomoTracker.trackGoal(10);
          matomoTracker.trackEvent("Site", "Final step modal v3");
        }
        await this.getSizeGuide();
      }
      this.oldSelectedOption.push(this.selectedOption);
      this.selectedOption = option;
    },
    updateOldSelectedOption() {
      this.selectedOption = this.oldSelectedOption.pop();
    },
    updateInput2(value) {
      store.state.user.modal_reco_sizeContent.product.selectedSizes.size_type = value;
    },
    updateInput3(value) {
      store.state.user.modal_reco_sizeContent.product.selectedSizes.height = value;
    },
    updateInput4(value) {
      store.state.user.modal_reco_sizeContent.product.selectedSizes.top = value;
    },
    updateInput5(value) {
      store.state.user.modal_reco_sizeContent.product.selectedSizes.bottom = value;
    },
    async verifyProductExist() {
      // customLogger("verifyProductExist");
      try {
        var currentUrl = window.location.href;
        var urlObj = new URL(currentUrl);
        urlObj.search = "";
        urlObj.hash = "";
        var link = urlObj.toString();
        let imgLink = document.querySelectorAll(".image-zoom-noo")[0].src;
        let name = document.querySelectorAll(".product-meta__title")[0].innerHTML;
        let price;
        try
        {
          price = document.querySelectorAll(".price.price--large")[1].childNodes[2].data;
        }
        catch (e)
        {
          price = document.querySelectorAll(".price.price--large")[0].childNodes[1]?.data;
        }
        // customLogger("----------------------------------------------------")
        // customLogger("----------------------------------------------------")
        // customLogger("link", link);
        // customLogger("name", name);
        // customLogger("imgLink", imgLink);
        // customLogger("price", price);
        // customLogger("----------------------------------------------------")
        // customLogger("----------------------------------------------------")
        this.productLink = link;
        this.productImgLink = imgLink;
        this.productName = name.toUpperCase();
        this.productPrice =  price ;
        this.setModal_reco_sizeContent();
        await this.verifyProductExistInDB();
      } catch (e) {
        // document.getElementById("cleed_size_reco").style.display = "none";
        this.isError = true;
        return;
      }
    },
    setModal_reco_sizeContent()
    {
      if (store.state.user.modal_reco_sizeContent === undefined) {
        store.state.user.modal_reco_sizeContent = {
          product: {
            link: this.productLink, // récuparation sur la page produit (href)
            imgLink: this.productImgLink, // récuparation sur la page produit (querySelector)
            name: this.productName, // récuparation sur la page produit (querySelector)
            price: this.productPrice, // récuparation sur la page produit (querySelector)
            totalSteps: this.totalSteps,
            sizes: {}, // bdd
            alertSize: {}, // bdd
            selectedSizes: {
              size_type: undefined,
              height: undefined,
              top: undefined,
              bottom: undefined,
              url: this.productLink,
              lang: store.state.user.lang,
            },
          },
          result: [] // reco
        }
      }
    },
    async getSizeGuide(){
      try {
        let data = store.state.user.modal_reco_sizeContent.product.selectedSizes;
        this.isLoading = true;
        let sizes = await this.$store.dispatch('FETCH_NOO_SIZE_GUIDE', {data});
        if (sizes.data.length === 0) {
          throw new Error('No size guide found');
        }
        this.resultSizes.value = sizes.data.value;
        // this.resultSizes.reponseText1 = this.getValueByPath(this.valueText, sizes.data.reponseText1);
        // this.resultSizes.reponseText2 = this.getValueByPath(this.valueText, sizes.data.reponseText2);
        // customLogger("sizes.data.responses", sizes.data.responses);
        this.resultSizes.response_one = (store.state.user.lang === 'fr') ? sizes.data.responses.response_one_fr : sizes.data.responses.response_one_eng;
        this.resultSizes.response_two = (store.state.user.lang === 'fr') ? sizes.data.responses.response_two_fr : sizes.data.responses.response_two_eng;
        this.resultSizes.response_three = (store.state.user.lang === 'fr') ? sizes.data.responses.response_three_fr : sizes.data.responses.response_three_eng;
        // customLogger("this.resultSizes", this.resultSizes);
        this.isLoading = false;
      } catch (e) {
        // customLogger(e);
        this.isError = 1;
        return;
      }
    },
    async verifyProductExistInDB() {
      // customLogger("verifyProductExistInDB");
      try {
        let url = store.state.user.modal_reco_sizeContent.product.selectedSizes.url;
        this.isLoading = true;
        let product = await this.$store.dispatch('FETCH_NOO_VERIFY_PRODUCT', { url });
        // customLogger("product", product);
        var index = product.data['index_modale']
        if (!index) {
          throw new Error('Product not found');
        }
        var i18n_question_1 = product.data['i18n_question_1'] || undefined;
        var i18n_question_2 = product.data['i18n_question_2'] || undefined;
        var i18n_question_3 = product.data['i18n_question_3'] || undefined;
        this.setNextSteps(index, [i18n_question_1, i18n_question_2, i18n_question_3]);
        this.isLoading = false;
      } catch (e) {
        // customLogger(e);
        // dispay none to the button with id guide-taille-cleed
        this.isError = 1;
        return;
      }
    },
    async getNooSizes(option) {
      if (store.state.user.lang === 'fr' && option === '1') {
        store.state.user.modal_reco_sizeContent.product.selectedSizes.size_type = "FR";
      }
      else if (option === '1') {
        await this.updateSelectedOption('2');
        return;
      }
      try {
        let url = store.state.user.modal_reco_sizeContent.product.selectedSizes.url;
        let size_type = store.state.user.modal_reco_sizeContent.product.selectedSizes.size_type;
        this.isLoading = true;
        let sizes = await this.$store.dispatch('FETCH_SIZES_NOO', { url, size_type });
        // customLogger("sizes", sizes);
        this.buttonsList3 = sizes.data[0];
        this.buttonsList4 = sizes.data[1];
        this.buttonsList5 = sizes.data[2];
        if (this.buttonsList3.length === 0 && this.buttonsList4.length === 0 && this.buttonsList5.length === 0) {
          throw new Error('No sizes found');
        }
        await this.updateSelectedOption(this.nextStep2);
        this.isLoading = false;
        // assigner les valeurs dans les datas correspondantes, si besoin faire un traitement sur les données
      } catch (error) {
        this.isError = 1;
        customLogger(error);
      }
    },
    setNextSteps(index, questions) {
      this.questionStep3 = this.getValueByPath(this.valueText, questions[2]);
      this.questionStep4 = this.getValueByPath(this.valueText, questions[0]);
      this.questionStep5 = this.getValueByPath(this.valueText, questions[1]);
      index = parseInt(index);
      this.totalSteps = (store.state.user.lang === 'fr') ? index : (index + 1);
      this.totalSteps = (index === 2) ? this.totalSteps - 1 : this.totalSteps;
      this.totalSteps = (this.totalSteps === 1) ? 0 : this.totalSteps;
      if (index === 3) {
        this.nextStep2 = '4';
        this.nextStep3 = '6';
        this.nextStep4 = '5';
        this.nextStep5 = '3';
      }
      else if (index === 2) {
        this.nextStep2 = '5';
        this.nextStep5 = '6';
      }
      else if (index === 1) {
        this.nextStep2 = '4';
        this.nextStep4 = '6';
      }
      else
        throw new Error('No size guide found');
    },
    addToCart() {
      // faire le traitement pour ajouter le produit au panier
      // faire le traitement pour fermer la modal
      // emit close modal
      this.$emit('close');
      try {
        if (window.matomoTracker) {
          customLogger("add to cart modal");
          matomoTracker.trackGoal(9);
          matomoTracker.trackEvent("Site", "Add to cart modal v3");
        }

        var size = this.resultSizes.value;
        const selectedSize = size;

        const sizeInputs = document.querySelectorAll('.block-swatch__radio');
        const addToCartButton = document.querySelector('#AddToCart');
        const notifyButton = document.querySelector('#SI_trigger');

        let selectedInput;
        let sizeAvailable = 0;

        for (const input of sizeInputs) {
          const label = input.parentElement;
          const labelText = label.textContent || label.innerText;

          if (labelText.trim() === selectedSize) {
            input.checked = true;
            selectedInput = input;
            sizeAvailable = label.classList.contains('is-disabled') ? -1 : 1;
            break;
          }
        }

        if (!selectedInput) {
          throw new Error(`Size ${selectedSize} not found.`);
        }

        const changeEvent = new Event('change', { bubbles: true });
        selectedInput.dispatchEvent(changeEvent);

        if (sizeAvailable === 1) {
          addToCartButton.click();
        } else {
          notifyButton.click();

          const iframe = document.querySelector('#SI_frame');
          const variantsSelect = iframe.contentDocument.querySelector('#variants');
          const options = variantsSelect.querySelectorAll('option');
          let sizeOptionFound = false;

          for (const option of options) {
            if (option.text === selectedSize) {
              variantsSelect.value = option.value;
              sizeOptionFound = true;
              break;
            }
          }

          if (!sizeOptionFound) {
            throw new Error(`Size ${selectedSize} not found in the iframe.`);
          }
        }
      } catch (e) {
        customLogger(e);
        customLogger("An error occurred while processing the selected size.");
      }


    },

    getValueByPath(obj, path) {
      let value = obj;
      if (path === undefined || obj === undefined)
        return undefined;
      for (let key of path) {
        // customLogger("key", key)
        if (value[key] === undefined) {
          return undefined;
        }
        value = value[key];
      }
      return value;
    }
  }
};
</script>

<style>
.modal-first-view-cleed h2 {
  height: 100px !important;
  margin-bottom: 10px !important;
  font-size: 16px !important;
}
</style>

<style scoped>
.bold-style-cleed {
  font-weight: bolder;
}

.loader-center {
  display: block;
  margin: auto;
  text-align: center;
}

.flex-modal-grow-cleed {
  flex-grow: 1 !important;
  display: flex !important;
  flex-direction: column !important;
}

.flex-modal-center-xy-cleed {
  align-items: center !important;
  justify-content: center !important;
  display: flex !important;
}
</style>

<style>
.has-NooClass {
  display: flex !important;
}
.modal-size-advice-cleed-has-NooClass{
  background-color: #F9F8F5 !important;
}
</style>
